import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import backgroundImage from './img/heroSection-bg.jpg';
import rightContentImage from './img/heroSection-main.png';

function HeroSectionWithParallax() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goContact = () => {
    navigate('/contact');
  };

  return (
    <section className="relative w-full min-h-screen flex items-center md:h-[540px] lg:overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-black bg-opacity-10" />
      <div className="absolute inset-0 bg-blue-900 bg-opacity-70" />

      <div className="container mx-auto px-4 relative z-10 h-full flex items-center py-16 lg:py-0">
        <div className="flex flex-col lg:flex-row items-center justify-between lg:justify-center gap-8 md:gap-12 lg:gap-16 w-full">
          <div className="w-full lg:w-1/2 text-center lg:text-left p-4 sm:p-6 lg:p-0">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-extrabold text-white leading-tight mb-4">
              {t('heroSection.title')}
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-8">
              {t('heroSection.description')}
            </p>
            <button
              onClick={goContact}
              className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-blue-500 focus:ring-opacity-50"
            >
              {t('heroSection.button')}
            </button>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-start mt-8 lg:mt-0 lg:ml-8">
            <img
              src={rightContentImage}
              alt="Wintriss Solution Diagram"
              className="max-w-full h-auto object-contain lg:max-w-md xl:max-w-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSectionWithParallax;
